import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PopupWrapper from '../../../../components/popup/PopupWrapper';
import {
  getButtonClass,
  resolvePopupPrimaryButtonSide,
  usePopupPrimaryButton,
} from '../../../../components/popup/popupUtils';
import { sanitizeHtml } from '../../../../assets/utils/comm/sanitize';

/**
 * 텍스트 팝업 컴포넌트
 * 간단한 확인/취소 팝업
 */
const TextPopup = ({ config, onClose }) => {
  const { t } = useTranslation();
  const primarySide = resolvePopupPrimaryButtonSide(config);

  const handleLeftButtonClick = useCallback(() => {
    const leftBtn = config?.leftButton;
    if (leftBtn?.submit) {
      onClose(true);
    } else {
      onClose(false);
    }
  }, [config?.leftButton, onClose]);

  const handleRightButtonClick = useCallback(() => {
    const rightBtn = config?.rightButton;
    if (rightBtn?.submit) {
      onClose(true);
    } else {
      onClose(false);
    }
  }, [config?.rightButton, onClose]);

  const handlePrimaryAction = useCallback(() => {
    if (primarySide === 'left') {
      handleLeftButtonClick();
      return;
    }
    handleRightButtonClick();
  }, [primarySide, handleLeftButtonClick, handleRightButtonClick]);

  const primaryButtonRef = usePopupPrimaryButton(config, handlePrimaryAction);

  return (
    <PopupWrapper
      config={config}
      onClose={onClose}
      displayType={config?.displayType || 'modal'}
      className="popup-text"
    >
      <div className="main-popup-body popup-text">
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(config?.content || t('popup.common.noContent')),
          }}
        />
      </div>
      <div className="main-popup-footer d-flex justify-content-between">
        {config?.leftButton && (
          <button
            type="button"
            ref={primarySide === 'left' ? primaryButtonRef : undefined}
            className={`btn main-popup-left-btn ${getButtonClass(config.leftButton.color || 'btn-secondary')}`}
            onClick={handleLeftButtonClick}
          >
            {config.leftButton.text || t('popup.common.cancel')}
          </button>
        )}
        {config?.rightButton && (
          <button
            type="button"
            ref={primarySide === 'right' ? primaryButtonRef : undefined}
            className={`btn main-popup-right-btn ${getButtonClass(config.rightButton.color || 'btn-primary')}`}
            onClick={handleRightButtonClick}
          >
            {config.rightButton.text || t('popup.common.confirm')}
          </button>
        )}
      </div>
    </PopupWrapper>
  );
};

export default TextPopup;

